<template>
  <footer>
  
  </footer>
</template>

<script>
export default {
  name: "Footer",
  components: {
    
  },
  methods: {
    
  },
  mounted() {
    
  }
}
</script>
